import React from 'react';
import { isMacOS } from './../../../../utils/isMacOS';
import { isFirefox } from './../../../../utils/isFirefox'
import NextArrow from '../../../../assets/Quiz/NextArrow.svg';
import NextArrowPng from '../../../../assets/Quiz/NextArrow.png';
import HorizonNextArrow from '../../../../assets/Quiz/Horizon/NextArrow.svg';
import HorizonNextArrowPng from '../../../../assets/Quiz/Horizon/NextArrow.png';
import BackArrow from '../../../../assets/Quiz/BackArrow.svg';
import BackArrowPng from '../../../../assets/Quiz/BackArrow.png';
import { isHorizon } from '../../../../utils/brandHelper';
import '../../../../pages/ChildrenApplication/components/ChildrenApplication.css';
import '../../../../pages/Details/components/DetailsLayout.css';
import './SurveyQuizNav.css';

const SurveyQuizNav = props => {
  const nextArrowPng = isHorizon ? HorizonNextArrowPng : NextArrowPng;
  const nextArrowSvg = isHorizon ? HorizonNextArrow : NextArrow;

  return (
    props.complete ? <div onClick={props.closeSurveyComplete} className="d-flex justify-content-center fs-15 closeSurvey">Close survey</div> 
    : 
    <div className="d-flex navButtonsWrapper justify-content-between surveyQuizNav">
        {!props.complete && <div className="d-flex align-items-center">
          {props.showPrevious && <div onClick={props.previousQuestion} className="d-flex align-items-center backQ justify-content-end">
                <img  className="navImg" src={!isMacOS() && isFirefox() ? BackArrowPng : BackArrow} />
                <div className='cPointer prevQ infoText'>Back</div>
          </div>}
        </div>}
      {props.showContinue && !props.complete && <div className={`d-flex align-items-center continueQ justify-content-start ${props.currentValueFullfilled() ? "enabled": "disabled"} questionI${props.currentQuestionI}`} onClick={props.nextQuestion}>
          <div className='cPointer font-weight-bold continue infoText'>Continue</div>
           <img src={ !isMacOS() && isFirefox() ? nextArrowPng : nextArrowSvg } className="navImg cPointer" />
        </div>}
    </div>
  );
};

export default SurveyQuizNav;
